<template>
  <div class="goods-page">

    <div class="goods-page__title hide-on-pad">{{ $t('breadcrumbs.goods') }}</div>

    <div class="count show-on-pad">
      <p class="title">{{ $t('breadcrumbs.goods') }}</p>
      <!-- <p class="count-text">全部共{{total}}件商品</p> -->
      <p class="count-text" v-t="{ path: 'goods.total_mobile', args: { total } }"></p>
      <class-picker :list="goodsInd" pagename="goods"></class-picker>
    </div>

    <div class="filter-bar c-layout">
      <div 
        class="filter-item mobile-style" 
        :class="{ active: isMobileMenuOpen }" 
        @click="handleMobileFilterMenuOpen"
        v-show="int"
      >
        <span class="filter-name">{{ (colorSelect || sizeSelect)?'':$t('goods.select') }}<div>{{ colorSelect?$t('goods.color')+':'+colorSelect:'' }}</div><div>{{ sizeSelect?$t('goods.color')+':'+sizeSelect:'' }}</div></span>
        <i class="filter-icon"></i>
      </div>
      <div class="mobile-filter-menu" v-show="int">
        <span class="mobile-filter-title show-on-pad"><span>{{ $t('goods.select') }}</span><Icon type="x" @clickevent="handleMobileFilterMenuClose" /></span>
        <div class="filter-item">
          <span class="filter-name" @click="toggleComBox">{{ $t('goods.size') }}<div class="toggle"></div></span>
          <i class="filter-icon"></i>
          <div class="size-box com-box checkbox-container">
            <label class="bui" v-for="(item,index) in filterSizeArray" :key="'size_'+index">
              <input type="checkbox" name="size_checkbox" @click="handleSelectChange($event,'size',item.standard_name)"/>
              <i class="bui-checkbox"></i>
              <span :class="{ active:sizeSelect==item.standard_name }">{{item.standard_name}}</span>
            </label>
          </div>
        </div>
        <div class="filter-item">
          <span class="filter-name" @click="toggleComBox">{{ $t('goods.color') }}<div class="toggle"></div></span>
          <i class="filter-icon"></i>
          <div class="color-box com-box checkbox-container">
            <label class="bui" v-for="(item) in filterColorArray" :key="'color_'+item.id">
              <input type="checkbox" name="color_checkbox" @click="handleSelectChange($event,'color',item.standard_name)"/>
              <img class="color-item-img" :class="{ active: colorSelect==item.standard_name }" :src="item.photo">
              <i class="bui-checkbox"></i>
              <span :class="{ active:colorSelect==item.standard_name }">{{item.standard_name}}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="filter-item hide-on-pad-flex">
        <span class="filter-name">{{ $t('goods.sort') }}<div style="font-size:12px">{{ sortIndex!==''?sortArray[sortIndex].name:'' }}</div></span>
        <i class="filter-icon"></i>
        <div class="sort-box com-box">
          <div
            class="sort-item"
            @click="handleSort(index)"
            :class="{'active':sortIndex === index}"
            v-for="(item,index) in sortArray"
            :key="index"
          >
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
      <div class="filter-item show-on-pad-flex" :class="{ active: isMobileSortMenuOpen }" @click="isMobileSortMenuOpen=!isMobileSortMenuOpen">
        <span class="filter-name">{{ $t('goods.sort') }}<div style="font-size:12px">{{ sortIndex!==''?sortArray[sortIndex].name:'' }}</div></span>
        <i class="filter-icon"></i>
        <div class="sort-box com-box">
          <div
            class="sort-item"
            @click.stop="handleSort(index)"
            :class="{'active':sortIndex === index}"
            v-for="(item,index) in sortArray"
            :key="index"
          >
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="goods-count c-layout hide-on-pad">显示1-20个商品，共{{total}}件商品</div> -->
    <div class="goods-count c-layout hide-on-pad" v-t="{ path: 'goods.total_pc', args: { total } }"></div>

    <!-- <div class="goods-filter-mobile">
      <div class="count">
        <p class="title">商品一览</p>
        <p>全部共{{total}}件商品</p>
      </div>
      <div class="filter-block">
        <div class="filter-item">
           筛选
        </div>
        <div class="filter-item">
          <span class="filter-name">排序方式</span>
          <i class="filter-icon"></i>
          <div class="sort-box com-box">
            <div
              class="sort-item"
              @click="sortIndex = index"
              :class="{'active':sortIndex === index}"
              v-for="(item,index) in sortArray"
              :key="index"
            >
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <div v-loading="loading">
      <div class="goods-list-0 c-layout">
        <GoodsItem :item="item" v-for="(item,index) in list" :key="index" @addcart="handleOpenAddCartDrawer"/>
      </div>
    </div>

    <!-- <Pagination
      v-if="list"
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @handleCurrentChange="handleCurrentChange"
      @handlePageIndex="handlePageIndex"
    /> -->
    <Pagination
      v-if="list"
      :pageSize="pageSize"
      :pages="currentPage"
      :total="total"
      :listLoading="loading"
      @handelPaginationChange="handleCurrentChange"
    />
    <GoodsFlexible :list="recommendList" :title="$t('goodsFlexible.recommend')" sub-title="RECOMMEND" tag="hot" />
    <GoodsFlexible :list="recentGoods"  :title="$t('goodsFlexible.recent')" sub-title="RECENT" tag="new" />
    <AddCartDrawer ref="drawer"/>
  </div>
</template>

<script>
import GoodsItem from "@/components/GoodsItem";
import GoodsFlexible from "@/components/GoodsFlexible";
// import Pagination from "@/components/Pagination";
import Pagination from '@/components/Pagination/NewPagination.vue';
import ClassPicker from '@/components/ClassPicker/index.vue';
import { getGoodsList, getProductSelect } from "@/api";
import Mixin from "@/utils/goodsMixin";
import { mapState } from 'vuex';
import AddCartDrawer from '../../components/AddCardDrawer/index.vue'

export default {
   mixins:[Mixin],
  data() {
    return {
      loading: false,
      total: 0,
      currentPage: 1,
      pageSize: 20, //每页显示多少条
      list: "",
      recommendSize: 12,
      recommendList: "",
      int: '',
      sortIndex: 0,
      colorSelect: '', // 筛选颜色
      sizeSelect: '', // 筛选尺寸
      isMobileMenuOpen: false,
      isMobileSortMenuOpen: false,
      // sortArray: [
      //   {
      //     id: 1,
      //     name: "按人气排序",
      //   },
      //   {
      //     id: 2,
      //     name: "按价格由高至低",
      //   },
      //   {
      //     id: 3,
      //     name: "按价格由低至高",
      //   },
      //   {
      //     id: 4,
      //     name: "按上架日期排序",
      //   },
      // ],
      sortArray: this.$t('goods.sort_array'),
      filterSizeArray: [
        // {
        //   id: 1,
        //   name: "ONE SIZE",
        // },
        // {
        //   id: 2,
        //   name: "XXS",
        // },
        // {
        //   id: 3,
        //   name: "XS",
        // },
        // {
        //   id: 4,
        //   name: "XS/S",
        // },
        // {
        //   id: 5,
        //   name: "M",
        // },
        // {
        //   id: 6,
        //   name: "M/Short",
        // },
        // {
        //   id: 7,
        //   name: "L/Short",
        // },
        // {
        //   id: 8,
        //   name: "XL",
        // },
        // {
        //   id: 9,
        //   name: "XXL",
        // },
      ],
      filterColorArray: [
        // {
        //   id: 21,
        //   standard_name: "黑",
        //   bg: "#000",
        // },
        // {
        //   id: 22,
        //   standard_name: "灰",
        //   bg: "#707070",
        // },
        // {
        //   id: 23,
        //   standard_name: "白",
        //   bg: "#fff",
        // },
        // {
        //   id: 24,
        //   standard_name: "红",
        //   bg: "#E50303",
        // },
        // {
        //   id: 25,
        //   standard_name: "橙",
        //   bg: "#FF9100",
        // },
        // {
        //   id: 26,
        //   standard_name: "黄",
        //   bg: "#FFF700",
        // },
        // {
        //   id: 27,
        //   standard_name: "绿",
        //   bg: "#099604",
        // },
        // {
        //   id: 28,
        //   standard_name: "蓝",
        //   bg: "#0095EE",
        // },
        // {
        //   id: 29,
        //   standard_name: "紫",
        //   bg: "#B600F6",
        // },
      ],
    };
  },
  computed: {
    ...mapState(['goodsInd'])
  },
  mounted() {
    let { category, store_id } = this.$route.query;
    this.int = category;
    
    // 如果有选择分类的话，进来才会有尺寸和颜色可以选
    this.getSelect(category, store_id);
    this.getList();
    this.getRecommendList();
  },
  methods: {
    async getSelect(category, store_id) {
      if(category) {
        // 取得尺寸和颜色
        const selectRes = await getProductSelect({
          ind: category,
          store_id
        });
        console.log('selectRes',selectRes);
        const { color, size } = selectRes.list;
        this.filterColorArray = color;
        this.filterSizeArray = size;
      }
    },
    async getList() {
      this.loading = true;
      const data = {};
      const { store_id } = this.$route.query;
      
      data.page = this.currentPage;
      data.list = this.pageSize;
      data.int = this.int;
      data.store_id = store_id;
      data.sort_ind = this.sortArray[this.sortIndex].id;
      data.color = this.colorSelect;
      data.size = this.sizeSelect;
      let res = await getGoodsList(data);
      this.list = res.list.data;
      this.total = res.list.total;
      this.loading = false;
    },
    handlePageIndex(val) {
      this.currentPage = val;
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },

    async getRecommendList(data) {
      let { category } = this.$route.query;
      getGoodsList({ int: category, recommend: this.recommendSize }).then((res) => {
        this.recommendList = res.recommend;
      });
    },
    handleMobileFilterMenuOpen(e) {
      this.isMobileMenuOpen = true;
    },
    handleMobileFilterMenuClose(e) {
      this.isMobileMenuOpen = false;
    },
    toggleComBox(e) {
      e.target.classList.toggle('active');
    },
    async handleOpenAddCartDrawer(pid) {
      // this.choosePid = pid;
      this.$refs.drawer.handleOpenAddCartDrawer(pid);
    },
    handleSort(index) {
      console.log('123123');
      this.isMobileSortMenuOpen = false;
      this.sortIndex = index;
      this.currentPage = 1;
      this.getList();
    },
    handleSelectChange(e,type,v) {
      this.currentPage = 1;
      // this.getList();
      // size_checkbox
      // colorSelect
      const checked = e.target.checked;
      console.log(document.querySelectorAll(`${type}_checkbox`));
      document.querySelectorAll(`[name="${type}_checkbox"]`).forEach(e => {
        e.checked = false;
      });
      console.log('checked',checked);
      if(checked) {
        e.target.checked = true;
        this[`${type}Select`] = v;
      }else{
        e.target.checked = false;
        this[`${type}Select`] = '';
      }

      this.getList();
    },
    // handleCleanSelect() {
    //   this.colorSelect = '';
    //   this.sizeSelect = '';
    //   this.currentPage = 1;
    //   this.getList();
    // }
  },
  components: {
    GoodsItem,
    GoodsFlexible,
    Pagination,
    ClassPicker,
    AddCartDrawer
  },
};
</script>

<style  lang='less'>
.goods-page {

  .goods-page__title {
    border-top: 2px solid var(--unnamed-color-A9A9A9);
    text-align: center;
    padding: 32px 0;

    font-weight: 500;
    font-size: 32px;
    line-height: 50px;
    color: var(--unnamed-color-111111);
  }
  .filter-bar {
    display: flex;
    align-items: center;
    height: 60px;
    border-top: 2px solid var(--unnamed-color-A9A9A9);
    border-bottom: 2px solid var(--unnamed-color-A9A9A9);
    color: var(---unnamed-color-707070);
    font-size: 16px;
    line-height: 24px;
    .mobile-filter-menu {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .filter-item {
      cursor: pointer;
      position: relative;
      display: flex;
      justify-content: center;
      margin: 0 20px;
      width: 140px;
      align-items: center;
      height: 100%;
      .filter-icon {
        margin-left: 15px;
        width: 30px;
        height: 18px;
        background: url("./images/20200801021919_12323.png") no-repeat;
        background-size: contain;
        background-position: center center;
      }
      .com-box {
        pointer-events: none;
        position: absolute;
        opacity: 0;
        transition: all 0.2s;
        left: -7px;
        top: 57px;
        padding: 22px 0px 11px 47px;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        width: 266px;
        height: 203px;
        z-index: 3;
        border: 1px solid var(---unnamed-color-707070);
        background: var(--unnamed-color-ffffff);
      }
      .size-box {
        .size-item {
          cursor: pointer;
          display: flex;
          align-items: center;
          margin-bottom: 8px;
          i {
            width: 13px;
            height: 13px;
            background: url("./images/20200801021919_1232423.png") no-repeat;
            background-size: contain;
            background-position: center center;
          }
          span {
            margin-left: 6px;
            font-weight: 500;
            font-size: 13px;
            line-height: 19px;
          }
        }
        .size-item.active {
          i {
            background: url("./images/20200801021919_12d.png") no-repeat;
            background-size: contain;
            background-position: center center;
          }
        }
      }
      .sort-box {
        padding: 0;
        height: 190px;
        width: 140px;
        left: -1px;
        .sort-item {
          cursor: pointer;
          display: flex;
          justify-content: center;
          padding: 13px 0;
          span {
            margin-left: 6px;

            font-size: 13px;
            line-height: 19px;
            font-weight: 500;
          }
        }
        .sort-item:hover {
          color: var(---unnamed-color-ec4f00);
        }
        .sort-item.active {
          color: var(---unnamed-color-ec4f00);
        }
      }
      .checkbox-container {
        margin-left: 6px;
        font-weight: 500;
        font-size: 13px;
        padding: 10px 0 0 25px;

        .bui {
          display: flex;
          align-items: center;
          position: relative;
          padding: 5px 0;
        }

        .bui input {
          cursor: pointer;
          position: absolute;
          left: 0;
          top: 0;
          z-index: 3;
          opacity: 0;
          width: 100%;
          height: 100%;
        }
        i {
          width: 13px;
          height: 13px;
        }
        span {
          margin-left: 8px;
          font-weight: 500;
          font-size: 13px;
          line-height: 19px;
          padding: 0 10px;
          &.active {
            background: #ec4f01;
            color: white;
          }
        }
        //没选中样式
        .bui input + .bui-checkbox {
          background: url("./images/20200801021919_1232423.png") no-repeat;
          background-size: contain;
          background-position: center center;
        }
        //选中样式
        .bui input:checked + .bui-checkbox {
          background: url("./images/20200801021919_12d.png") no-repeat;
          background-size: contain;
          background-position: center center;
        }
      }
      .color-box {
        i {
          border: 1px solid var(---unnamed-color-707070);
        }
        //没选中样式
        .bui input + .bui-checkbox {
          border: 1px solid var(---unnamed-color-707070);
        }
        //选中样式
        .bui input:checked + .bui-checkbox {
          border: 2px solid var(--unnamed-color-000000);
        }
        .color-item-img {
          width: 16px;
          position: absolute;
          top: 6px;
          left: -2px;
          &.active {
            border: 1px solid black;
          }
        }
      }
      &.mobile-style {
        align-items: center;
        justify-content: flex-start;
        width: auto;
        margin-right: 0;
        &:hover {
          background: unset;
          border: unset;
          .filter-name {
            color: black;
          }
        }
        .filter-icon {
          display: none;
        }
      }
    }
    .filter-item:last-child {
      margin-left: auto;
      margin-right: 0;
    }
    .filter-item:nth-last-child(2) {
      margin-left: auto;
      margin-right: 0;
    }
    @media (min-width: 992px) {
      .filter-item:hover {
        background: var(---unnamed-color-ec4f00);
        border-left: 1px solid rgba(112, 112, 112, 1);
        border-right: 1px solid rgba(112, 112, 112, 1);
        .filter-name {
          color: var(--unnamed-color-ffffff);
        }
        .filter-icon {
          background: url("./images/20200801021919_12.png") no-repeat;
          background-size: contain;
          background-position: center center;
        }
        .com-box {
          pointer-events: initial;
          opacity: 1;
          z-index: 10000;
        }
      }
    }
    .filter-item.active {
      background: var(---unnamed-color-ec4f00);
      border-left: 1px solid rgba(112, 112, 112, 1);
      border-right: 1px solid rgba(112, 112, 112, 1);
      .filter-name {
        color: var(--unnamed-color-ffffff);
      }
      .filter-icon {
        background: url("./images/20200801021919_12.png") no-repeat;
        background-size: contain;
        background-position: center center;
      }
      .com-box {
        pointer-events: initial;
        opacity: 1;
        z-index: 10000;
      }
    }
  }
  .goods-count {
    padding-top: 16px;
    padding-bottom: 32px;
    color: var(---unnamed-color-707070);

    font-size: 16px;
    line-height: 24px;
  }
  .goods-list-0 {
    display: flex;
    flex-wrap: wrap;
    .goods-item-comp {
      margin-right: 29px;
    }
    .goods-item-comp:nth-child(4n) {
      margin-right: 0;
    }
  }
  .goods-flexble-comp {
    margin-bottom: 15px;
  }
  .pagination-comp {
    margin-bottom: 55px;
    margin-top: 25px;
  }

  @media (max-width: 992px) {
    // padding: 20px;
    .count {
      padding: 0 20px;
      padding-top: 20px;
      .title {
        font-size: 1.8rem;
        margin-bottom: 5px;
      }
      .count-text {
        margin-bottom: 20px;
      }
    }
    .filter-bar{
      display: flex;
      // margin-bottom: 20px;
      // margin-top: 20px;
      margin: 20px;
      width: calc(100% - 40px);
      position: relative;
      border: 2px solid var(--unnamed-color-A9A9A9);
      &>.filter-item {
        flex: 1;
      }
      .filter-item {
        justify-content: space-between;
        margin: 0;
        padding: 15px;
        border-right: 2px solid #707070;
        &:nth-last-child(1){
          border-right: unset;
        }
        .sort-box {
          width: 100%;
        }
        &.mobile-style {
          align-items: center;
          justify-content: space-between;
          width: auto;
          .filter-icon {
            display: block;
          }
          &:hover {
            background: unset;
            .filter-name {
              color: var(---unnamed-color-707070);
            }
            .filter-icon {
              background: url("./images/20200801021919_12323.png") no-repeat;
              background-size: contain;
              background-position: center center;
            }
          }
          &.active+.mobile-filter-menu {
            display: flex;
            
          }
        }
      }
      .mobile-filter-menu {
        display: none;
        flex-direction: column;
        position: absolute;
        z-index: 5;
        width: 100vw;
        height: auto;
        background: white;
        left: -20px;
        top: -3px;
        border: 1px solid #707070;
        padding: 0 20px;
        .mobile-filter-title {
          display: block;
          width: 100%;
          padding: 20px;
          color: black;
          position: relative;
          .cloud-icon {
            position: absolute;
            top: 24px;
            right: 4px;
            width: 14px;
            height: 14px;
          }
        }
        .filter-item {
          width: 100%;
          height: 100%;
          border: unset;
          flex-direction: column;
          border-top: 1px solid #ddd;
          padding-right: 0;
          .filter-icon {
            display: none;
            pointer-events: none;
          }
          .filter-name {
            pointer-events: none;
            display: block;
            width: 100%;
            position: relative;
            pointer-events: visible;
            .toggle {
              pointer-events: none;
              position: absolute;
              width: 24px;
              height: 24px;
              right: 0px;
              top: 0;
              background-image: url("data:image/svg+xml,%3Csvg t='1599044278122' class='icon' fill='%237F7F7F' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='3251'%3E%3Cpath d='M512 853.333333c-25.6 0-42.666667-17.066667-42.666667-42.666666V213.333333c0-25.6 17.066667-42.666667 42.666667-42.666666s42.666667 17.066667 42.666667 42.666666v597.333334c0 25.6-17.066667 42.666667-42.666667 42.666666z' p-id='3252'%3E%3C/path%3E%3Cpath d='M810.666667 554.666667H213.333333c-25.6 0-42.666667-17.066667-42.666666-42.666667s17.066667-42.666667 42.666666-42.666667h597.333334c25.6 0 42.666667 17.066667 42.666666 42.666667s-17.066667 42.666667-42.666666 42.666667z' p-id='3253'%3E%3C/path%3E%3C/svg%3E");
              background-size: 100% 100%;
            }
            &.active {
              .toggle {
                background-image: url("data:image/svg+xml,%3Csvg t='1599044219053' viewBox='0 0 1024 1024' version='1.1' fill='%23707070' xmlns='http://www.w3.org/2000/svg' p-id='2513'%3E%3Cpath d='M128 480h768a32 32 0 0 1 0 64H128a32 32 0 1 1 0-64z' fill-opacity='.7' p-id='2514'%3E%3C/path%3E%3C/svg%3E");
                background-size: 100% 100%;
              }
              &~.com-box {
                display: flex;
              }
            }
          }
          .com-box {
            pointer-events: none;
            touch-action: none;
            display: none;
            width: 100%;
            height: auto;
            position: relative;
            opacity: 1;
            top: 0;
            left: 0;
            margin: 0;
            padding: 0;
            border: unset;
            padding-top: 10px;
            flex-direction: row;
            flex-wrap: wrap;
            .bui {
              flex: 0 0 50%;
            }
          }
          &:hover {
            background: white;
            .filter-name {
              color: black
            }
            .com-box {
              pointer-events: initial;
            }
          }
        }
      }
    }
    .goods-list-0 {
      padding: 0 20px;
      .goods-item-comp {
        &:nth-child(2n-1) {
          padding-right: 15px;
          }
        &:nth-child(2n) {
          padding-left: 15px;
        }
      }
    }
  }
}
</style>
